<template>
  <div class="headerBox">
    <div class="header-left">
      <!-- 折叠图标 -->
      <div class="collapsemenu" @click="collapsemenu">
        <img v-if="collapse" src="@/assets/images/opne_menu.png" width="29px" height="29px" />
        <img v-else src="@/assets/images/collapse_menu.png" width="29px" height="29px" />
      </div>
      <!-- 竖线 -->
      <div class="verticaLline"></div>
      <!-- 系统logo -->
      <div class="imgBox">
        <img src="@/assets/images/reception_logo.png" />
      </div>
    </div>
    <div class="header-right">
      <!-- 机构中心或者企业中心 -->
      <div class="rght01">
        <div class="text">{{ flag === 0 ? '机构中心' : '企业中心' }}</div>
        <div class="transverse"></div>
      </div>
      <!-- 显示系统使用名称 -->
      <div class="rght02">
        <img src="@/assets/images/avatar.png" alt="" width="33px" height="33px" style="cursor: pointer" />
        <el-dropdown trigger="click" placement="bottom" @command="handleCommand">
          <span class="el-dropdown-link"> {{ company_name ? '' : $store.state.user.enterName }}<i
              class="el-icon-caret-bottom"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="infoMation" v-if="unitType === 1">
              <i class="el-icon-user-solid"></i>
              用户信息</el-dropdown-item>
            <el-dropdown-item command="loginOut">
              <i class="el-icon-switch-button"></i>
              安全退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 返回平台首页 -->
      <div class="rght03">
        <div class="imgBox" @click="back_homepage">
          <img src="@/assets/images/back@2x.png" width="20px" height="10px" />
        </div>
        <div class="text" @click="back_homepage">返回平台首页</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['flag', 'collapse', 'company_name'],
  computed: {
    ...mapGetters(['unitType'])
  },
  methods: {
    collapsemenu() {
      // 触发父组件的事件，点击展开和折叠左侧菜单
      this.$emit('collapsemenu')
    },
    // 点击回到平台首页
    back_homepage() {
      this.$router.push('/index')
    },
    // 点击下拉菜单
    handleCommand(val) {
      if (val === 'loginOut') {
        this.loginOut()
      } else if (val === 'infoMation') {
        // 判断当前是企业还是机构
        if (this.unitType === 1) {
          this.$router.push('/enterprise/accountInformation')
        } else {
          this.$router.push('/mechanism/mechanismInfomation')
        }
      }
    },
    // 退出
    loginOut() {
      // console.log('退出')
      this.$confirm('此操作退出, 是否继续?', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$store.dispatch('user/logout').then(() => {
            this.$router.push('/')
          })
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
        })
        .catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.headerBox {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-left {
    display: flex;
    align-items: center;
    margin-top: 17px;
    margin-bottom: 15px;

    .collapsemenu {
      cursor: pointer;
    }

    .verticaLline {
      width: 1.34px;
      height: 29.34px;
      background: #ffffff;
      margin-left: 20px;
    }

    .imgBox {
      width: 464px;
      height: 47px;
      margin-left: 20px;

      img {
        width: 464px;
        height: 47px;
      }
    }
  }

  .header-right {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 54px;

    // border: 1px solid red;
    .rght01 {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      margin-bottom: 30px;
      cursor: pointer;

      .text {
        font-weight: 400;
        width: 100px;
        height: 20px;
        font-size: 20.15px;
        color: #f2f4f5;
        margin-bottom: 15px;
      }

      .transverse {
        width: 30px;
        height: 3.03px;
        border-radius: 1.5px 1.5px 1.5px 1.5px;
        background: #f2f4f5;
      }
    }

    .rght02 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 54px;
      margin-right: 32px;
      margin-left: 34px;

      .head_picture {
        width: 33.6px;
        height: 33.84px;
        background: #005aff;
        border-radius: 50%;
        box-shadow: 0 0 10px 0 #02000026;
        background-image: url('~@/assets/images/avatar.png');
      }

      span {
        height: 15px;
        font-size: 15.11px;
        font-weight: 400;
        color: #ffffff;
        margin-left: 10.3px;
        cursor: pointer;
      }

      i {
        margin-left: 7px;
      }
    }

    .rght03 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 166.94px;
      height: 40.28px;
      border-radius: 19.99px 19.99px 19.99px 19.99px;
      background-color: #608ff8;

      .text {
        font-weight: 400;
        font-size: 16.12px;
        color: #f2f4f5;
        cursor: pointer;
        margin-left: 9px;
      }

      .imgBox {
        width: 16px;
        height: 17px;
        cursor: pointer;

        img {
          width: 16px;
          height: 17px;
        }
      }
    }
  }
}
</style>
